import { jwtDecode } from 'jwt-decode';

export interface JwtTokenPayload {
  customer_id: string;
  fb_id: string;
  ahamove_id: string;
  phone: string;
  iss: string;
  exp: number;
  iat: number;
}

export const decodeToken = (accessToken: string) => {
  let decoded: JwtTokenPayload | null = null;

  try {
    decoded = jwtDecode<JwtTokenPayload>(accessToken);
  } catch (error) {
    console.trace('Invalid jwt token', error);
  }

  return decoded;
};
